import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=100b562a&scoped=true"
import script from "./InformacionGeneral.vue?vue&type=script&lang=js"
export * from "./InformacionGeneral.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneral.vue?vue&type=style&index=0&id=100b562a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b562a",
  null
  
)

export default component.exports